// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cGur","toggleWrap":"styles_toggleWrap__Ehx2x","content":"styles_content__E6-W5","selectAreaCode":"styles_selectAreaCode__1ueKz"};